module.exports = __webpack_public_path__ + "img/chest.30c5e2d3.png";